module.exports = __webpack_public_path__ + "img/item8.24ed7ab4.png";